export class PetProfileModel {
    profile_sequence: number
    pet_no: number
    profile_date: number
    profile_type: string
    profile: string
    staff: number
    pet_name?: string

    constructor(
        profile_sequence: number,
        pet_no: number,
        profile_date: number,
        profile_type: string,
        profile: string,
        staff: number,
        pet_name?: string
    ) {
        this.profile_sequence = profile_sequence
        this.pet_no = pet_no
        this.profile_date = profile_date
        this.profile_type = profile_type
        this.profile = profile
        this.staff = staff
        this.pet_name = pet_name
    }
}